import { useCallback, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { createAsyncValidator } from '@alf/validators';
import InputField from '../../common/InputField';
import { usePinParsingFlow } from './hooks/usePinParsingFlow';
import { getPinType, isPinCode, pinCodeValidator } from './utils';

const PinCodeInput = ({
  rules = {},
  isForAllCountries = false,
  parseOnBlur = false,
  ...props
}) => {
  const methods = useFormContext();
  const { watch, setValue, register } = methods;

  const chosenCountry = watch('country');

  const parsingProcess = usePinParsingFlow({
    name: props.name
  });

  useEffect(() => {
    register('pinType');
  }, [register]);

  useEffect(() => {
    const pinType = getPinType(chosenCountry);
    setValue('pinType', pinType);
  }, [chosenCountry, setValue]);

  const handleBlur = useCallback(
    (e) => {
      if (parseOnBlur) {
        parsingProcess.start(props.onBlur);
      } else {
        props.onBlur?.(e);
      }
    },
    [parseOnBlur, parsingProcess, props]
  );

  if (isForAllCountries || isPinCode(chosenCountry)) {
    return (
      <InputField
        rules={{
          ...rules,
          ...createAsyncValidator((value) =>
            pinCodeValidator(value, watch('country'))
          )
        }}
        {...props}
        onBlur={handleBlur}
      />
    );
  }
  return null;
};

export default PinCodeInput;
